// routes
import { PATH_DASHBOARD } from '@raas/shared/src/routes/paths';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.overview.root;
